export default "__VITE_ASSET__acd4a400__"